import { IProduct } from 'src/types/product';

export const getVisibleElementById = <K extends keyof HTMLElementTagNameMap>(
  id: string,
): HTMLElementTagNameMap[K] | null => {
  const goodId = id.startsWith('#') ? id : `#${id}`;
  const elements = document.querySelectorAll<HTMLElementTagNameMap[K]>(goodId);

  const visible = Array.from(elements).filter(el => {
    const style = window.getComputedStyle(el);
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      el.offsetHeight !== 0
    );
  });
  return visible[0] || null;
};

export const getVisibleElementsById = <K extends keyof HTMLElementTagNameMap>(
  id: string,
) => {
  const goodId = id.startsWith('#') ? id : `#${id}`;
  const elements = document.querySelectorAll<HTMLElementTagNameMap[K]>(goodId);

  const visible = Array.from(elements).filter(el => {
    const style = window.getComputedStyle(el);
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      el.offsetHeight !== 0
    );
  });
  return visible;
};

export const elementIsInvisible = (el: HTMLElement) => {
  if (el) {
    const style = window.getComputedStyle(el);
    return (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      el.offsetHeight === 0
    );
  }
  return false;
};

export const setInputValue = (id: string, value = '') => {
  const el = getVisibleElementById<'input'>(id);
  if (el) {
    el.value = value;
  }
};

export const addDataParamsToElement = (
  elementIds: string[],
  selectedAddon: IProduct,
) => {
  if (window.DEBUG) {
    console.log('elementIds: ', elementIds);
    console.log('selectedAddon: ', selectedAddon);
  }
  if (Array.isArray(elementIds) && selectedAddon) {
    elementIds.forEach(id => {
      const elements = document.querySelectorAll<HTMLElement>(`#${id}`);
      if (window.DEBUG) {
        console.log('elements: ', elements);
      }
      elements.forEach(element => {
        if (window.DEBUG) {
          console.log('element: ', element);
        }
        element.setAttribute('data-product-name', `${selectedAddon.name}`);
        element.setAttribute(
          'data-shipping-price',
          `${selectedAddon.shippingPrice}`,
        );
        element.setAttribute('data-full-price', `${selectedAddon.fullPrice}`);
        element.setAttribute('data-quantity', `${selectedAddon.quantity}`);
        element.setAttribute('data-final-price', `${selectedAddon.finalPrice}`);
        element.setAttribute('data-currency', `${selectedAddon.currencyCode}`);
        element.setAttribute('data-product-id', `${selectedAddon.id}`);
        element.setAttribute(
          'data-discount-price',
          `${selectedAddon.discountPrice}`,
        );
      });
    });
  }
};
